import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { completeSubject } from 'src/app/common/app.helpers';

@Injectable()
export class MapMarkService implements OnDestroy {
  private clearMapMark$: Subject<void> = new Subject();

  public get clearMapMarkChanges(): Observable<void> {
    return this.clearMapMark$.asObservable();
  }

  public ngOnDestroy(): void {
    completeSubject(this.clearMapMark$);
  }

  public clearMapMarker(emptyMark?: boolean): void {
    if (emptyMark) {
      this.clearMapMark$.next();
    }
  }
}
